import type { ChartSymbol } from '../../types/api';
import type { LibrarySymbolInfo } from '../../types/datafeed-api';

export function toLibrarySymbolInfo(symbol: ChartSymbol): LibrarySymbolInfo {
  return {
    ticker: symbol.name,
    name: symbol.name,
    description: symbol.description,
    type: symbol.type,
    session: '24x7',
    timezone: 'Etc/UTC',
    exchange: symbol.exchange,
    listed_exchange: symbol.exchange,
    minmov: 1,
    pricescale: symbol.pricescale,
    has_intraday: true,
    has_weekly_and_monthly: true,
    supported_resolutions: ['1', '5', '15', '30', '60', '240', '1D', '1W', '9W'],
    intraday_multipliers: ['1', '5', '15', '30', '60', '240'],
    volume_precision: 4,
    data_status: 'streaming',
  };
}
